$(document).ready(function () {

    $('.tab-btn').on('click', function () {

        var targetId = $(this).data('tab');
        var $targetTab = $('#' + targetId);

        // ACTIVE BUTTON
        $('.tab-btn')
            .removeClass('active')
            .attr('aria-selected', 'false');

        $(this)
            .addClass('active')
            .attr('aria-selected', 'true');

        // HIDE TABS
        $('.tab-content').removeClass('active');

        // SHOW CURRENT TAB
        $targetTab.addClass('active');

        // WAIT FOR DISPLAY UPDATE
        setTimeout(function () {

            /* =========================
               FIX GROUP SLIDER
            ========================= */

            $targetTab.find('.groupSlider').each(function () {

                var $slider = $(this);

                // DESTROY OLD INSTANCE
                var flkty = Flickity.data(this);

                if (flkty) {
                    flkty.destroy();
                }

                // RE-INIT
                $slider.flickity({
                    cellAlign: 'center',
                    wrapAround: false,
                    groupCells: true,
                    contain: true,
                    pageDots: true,
                    prevNextButtons: true,
                    imagesLoaded: true,
                    adaptiveHeight: true,
                    draggable: true,
                    freeScroll: false,
                    touchVerticalScroll: true
                });

            });


            /* =========================
               FIX THUMBNAIL SLIDER
            ========================= */

            $targetTab.find('.larg-slider').each(function () {

                var flkty = Flickity.data(this);

                if (flkty) {

                    flkty.resize();
                    flkty.reloadCells();
                    flkty.reposition();

                }

            });

        }, 300);

    });

});